import { useState, useEffect } from "react";
import ScrollButton from "./ScrollButton";
import IntroButton from "./IntroButton";

const IndexSidebar = () => {
  const [showIntroButton, setShowIntroButton] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);

  // Show the intro button after a delay
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowIntroButton(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Show/hide scroll button based on scroll position
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 200);
    };
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Handle scroll to top action
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className="fixed bottom-20 right-6 z-40 flex flex-col gap-4">
      {/* Back to top button */}
      {showScrollButton && (
        <ScrollButton 
          direction="up" 
          visible={showScrollButton} 
          onClick={handleScrollToTop} 
        />
      )}
      
      {/* Preview intro button */}
      <IntroButton show={showIntroButton} />
    </div>
  );
};

export default IndexSidebar;
